import React from "react";

import "../styles/cookies.css";

const Cookies = () => {
    function acceptCookies(){
        document.getElementById("Cookies").style.display = "none";
        document.getElementById("CookieProtection").style.display = "none";
    }

    return (
        <div>
            <div id="CookieProtection">
            </div>
                <div id='Cookies'>
                    <h1>Terms of Service & Privacy Policy</h1>
                    <p>By accessing or using this website and its services, including generating reports, submitting feedback, or reporting issues, you agree to the following terms:
                        <ul>
                            <li >
                                <b>Data Collection and Storage:</b> We may collect and store certain information about you, including your IP address for a limited period (18 Hours) to prevent spam and malicious activity. Additionally, we will store all the data you submit through the website, such as reports and feedback.
                            </li>
                            <li>
                                <b>Your Consent:</b> Your continued use of this website constitutes your consent to our collection and storage of this information.
                            </li>
                        </ul>
                        <div className="text-center">
                            <b className="text-red">Disagreement:</b> If you do not agree to these terms, you are prohibited from using this website and its services.
                            <br />
                            If you want your data removed, please contact us at <a className="text-white" href="mailto:educare.info.ai@gmail.com">educare.info.ai@gmail.com</a>.
                            <br />
                            <b>No data we save can be traced back to you, unless you provide identifying information yourself.</b>
                        </div>
                    </p>
                    <div className="text-center">
                    <button id="DeclineCookies" onClick={() => window.location.href = "https://www.google.com"}>Decline</button>
                        <button id="AcceptCookies" onClick={() => acceptCookies()}>Accept</button>
                    </div>
                </div>
        </div>
    );
}

export default Cookies;